import {
	ContractLoadingSummary,
	ContractSummary,
	ContractSummaryDetail,
	ContractSummaryStatus,
} from '@services/contractLoading.types'

import { mockPurchase } from './directDeals.mock'

export const contractLoadingSummary: ContractLoadingSummary = {
	total: 3,
	accepted: 1,
	pending: 1,
	rejected: 1,
	acceptedAnnualTotalSavings: 2823.31,
}

export const contractsForReview: ContractSummary[] = [
	{
		id: 15,
		marketBasketId: 2579,
		termSetId: 'CO-393104',
		termSetName: 'Imaginal Disk',
		topLevelCustomerName: 'Magdalena Bay',
		topLevelCustomerPlid: 'CL-1158897',
		manufacturerName: 'Death & Romance',
		manufacturerPlid: 'MA-1018977',
		onContract: false,
		numProducts: 1,
		recommend: true,
		requiresPriceImplementation: false,
		directDealRejected: false,
		status: ContractSummaryStatus.PENDING,
		annualPurchaseVolume: 8220.03,
		dateRangePurchaseVolume: 180.66,
		annualPriceSavings: 3580.72,
		dateRangePriceSavings: 78.7,
		dateRangePriceSavingsExact: 0,
		annualRebateSavings: 203.94,
		dateRangeRebateSavings: 4.48,
		dateRangeRebateSavingsExact: 0,
		annualTotalSavings: 3784.67,
		dateRangeTotalSavings: 83.18,
		dateRangeTotalSavingsExact: 0,
		savingsPercentage: 46.04,
		createdAt: '2026-07-22T16:17:16.482488-04:00',
		updatedAt: null,
	},
	{
		id: 16,
		marketBasketId: 2579,
		termSetId: 'CO-393112',
		termSetName: 'Remain in Light',
		topLevelCustomerName: 'Talking Heads',
		topLevelCustomerPlid: 'CL-1158898',
		manufacturerName: 'Once in a Lifetime',
		manufacturerPlid: 'MA-1000034',
		onContract: false,
		numProducts: 1,
		recommend: true,
		requiresPriceImplementation: true,
		directDealRejected: false,
		status: ContractSummaryStatus.ACCEPTED,
		annualPurchaseVolume: 9134.58,
		dateRangePurchaseVolume: 200.76,
		annualPriceSavings: 2253.01,
		dateRangePriceSavings: 49.52,
		dateRangePriceSavingsExact: 0,
		annualRebateSavings: 570.3,
		dateRangeRebateSavings: 12.53,
		dateRangeRebateSavingsExact: 0,
		annualTotalSavings: 2823.31,
		dateRangeTotalSavings: 62.05,
		dateRangeTotalSavingsExact: 0,
		savingsPercentage: 30.91,
		createdAt: '2026-07-22T16:17:16.482488-04:00',
		updatedAt: null,
	},
	{
		id: 25,
		marketBasketId: 2579,
		termSetId: 'CO-399058',
		termSetName: 'Parallel Lines',
		topLevelCustomerName: 'Blondie',
		topLevelCustomerPlid: 'CL-1158899',
		manufacturerName: 'Heart of Glass',
		manufacturerPlid: 'MA-1000313',
		onContract: false,
		numProducts: 2,
		recommend: false,
		requiresPriceImplementation: false,
		directDealRejected: true,
		status: ContractSummaryStatus.REJECTED,
		annualPurchaseVolume: 7522.52,
		dateRangePurchaseVolume: 165.33,
		annualPriceSavings: 2065.52,
		dateRangePriceSavings: 45.4,
		dateRangePriceSavingsExact: 6.92,
		annualRebateSavings: 370.32,
		dateRangeRebateSavings: 8.14,
		dateRangeRebateSavingsExact: 5.43,
		annualTotalSavings: 2435.84,
		dateRangeTotalSavings: 53.54,
		dateRangeTotalSavingsExact: 12.34,
		savingsPercentage: 32.38,
		createdAt: '2026-07-22T16:17:16.482488-04:00',
		updatedAt: null,
	},
]

export const contractForReviewDetail: ContractSummaryDetail = {
	summary: contractsForReview[0],
	purchaseCounts: {
		total: 3,
		stocked: 2,
		notStocked: 1,
	},
	purchases: [
		{
			...mockPurchase,
			id: 901,
			description: 'Clone Hero Retail Blend',
			matchedProduct: {
				...mockPurchase.matchedProduct,
				stocked: true,
			},
		},
		{
			...mockPurchase,
			id: 902,
			description: 'Superunknown Frozen Fries',
			matchedProduct: {
				...mockPurchase.matchedProduct,
				stocked: false,
			},
		},
		{
			...mockPurchase,
			id: 903,
			description: 'Pink Flag Paper Boats',
			matchedProduct: {
				...mockPurchase.matchedProduct,
				stocked: true,
			},
		},
	],
}
